import css from 'styled-jsx/css';
import { icons } from '../../../config/styles';
import { svgToDataUri } from '../../../utils/styles/svgMixins';

export const ReaconditionedContainerStyle = css`
  /* Block: Main component */
  .reaconditioned {
    display: flex;
    align-items: center;
    gap: 12px;
    line-height: 1.4;
    margin-top: 0;

    width: 100%;
  }

  /* Elements: Icon container and icon */
  .reaconditioned__icon-container {
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }

  .reaconditioned__icon {
    display: block;
    width: 20px;
    height: 20px;
    background-image: url('${svgToDataUri(icons.reaconditionedIcon)}');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  /* Elements: Content container */
  .reaconditioned__content {
    flex: 1;
    color: #333333;
  }

  /* Elements: Text container for inline layout */
  .reaconditioned__text {
    display: inline;
    font-size: 12px;
    line-height: 1.4;
  }

  .reaconditioned__description {
    color: #767676;
    -webkit-letter-spacing: 0.2px;
    -moz-letter-spacing: 0.2px;
    -ms-letter-spacing: 0.2px;
    letter-spacing: 0.2px;
    line-height: 16px;
    letter-spacing: 0;
    margin: 0 12px 0 0;
  }

  .reaconditioned__description--highlight {
    font-weight: 700;
  }

  /* Elements: Link styling */
  .reaconditioned__link {
    background: none;
    border: none;
    color: #767676;
    cursor: pointer;
    text-decoration: underline;
    font-size: 12px;
    font-weight: normal;
    line-height: 16px;
    transition: color 0.2s ease;
    letter-spacing: 0;
    margin-left: 0;
    padding: 0;
  }

  .reaconditioned__link:hover {
    color: #000000;
    text-decoration: underline;
  }

  .reaconditioned__link:focus {
    outline-offset: 2px;
  }

  /* Responsive design */
  @media screen and (max-width: 1023px) {
    .reaconditioned {
      padding: 10px 12px;
      gap: 10px;
      margin-bottom: 12px;
    }

    .reaconditioned__icon {
      width: 18px;
      height: 18px;
    }

    .reaconditioned__link {
      font-size: 13px;
    }
  }

  /* Accessibility improvements */
  @media (prefers-reduced-motion: reduce) {
    .reaconditioned__link {
      transition: none;
    }
  }

  @media (prefers-contrast: high) {
    .reaconditioned__link {
      text-decoration-thickness: 2px;
    }
  }
`;
